import {
  Checkbox,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useTheme
} from "@mui/material";
import _ from "lodash";
import moment from "moment";
import React, { memo, useEffect, useRef, useState } from "react";
import { useStyle } from "../style";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import axios from "axios";
const BillingTable = ({data, setData, setPostData , forwardRef,setVerifyEnable,verifyEnable}) => {
  const theme = useTheme();
  const dispatch = useDispatch()
  const classes = useStyle();
  const[active, setActive] = useState(null)
  const [code, setCode] = useState('')
  const qtyRef = useRef(null)
  const [verify , setVerify] = useState("");
  const[barCode ,setBarCode] = useState("")
  const [docName, setDocName] = useState('')
  function getSelectedRow(e){
setActive(e)
const arr=[...data]
   }
   console.log(data,'Data Vanthudu')
function handleQtyChange(e){
  const arr=[...data]
  setData([])
  const inputValue = e.target.value.replace(/[^0-9]/g, '');
  // Ensure the value is below the specified maximum
  const numericValue = inputValue ? parseInt(inputValue, 10) : 0;
  const sanitizedValue = Math.min(numericValue, parseFloat(arr[active].qty));
  // arr[active].retQty = sanitizedValue
  // arr[active].totalAmt = sanitizedValue * arr[active].rate
  // setData(arr)
  if(sanitizedValue===0){
    arr[active].retQty = sanitizedValue
    arr[active].gst_amt = parseFloat(( arr[active].rate - arr[active].rate * arr[active].dis_per / 100) * (arr[active].gst_per / 100 * arr[active].qty)).toFixed(0)
    arr[active].cess_amt = parseFloat(( arr[active].rate - arr[active].rate * arr[active].dis_per / 100) * (arr[active].cess_per / 100 * arr[active].qty)).toFixed(0)
    arr[active].totalAmt = parseFloat(arr[active].qty * ( arr[active].rate - arr[active].rate * arr[active].dis_per / 100)).toFixed(0)
    setData(arr)
    }
    else{
      arr[active].retQty = sanitizedValue
      arr[active].gst_amt = parseFloat(( arr[active].rate - arr[active].rate * arr[active].dis_per / 100) * (arr[active].gst_per / 100 * sanitizedValue)).toFixed(0)
      arr[active].cess_amt = parseFloat(( arr[active].rate - arr[active].rate * arr[active].dis_per / 100) * (arr[active].cess_per / 100 * sanitizedValue)).toFixed(0)
      arr[active].totalAmt = sanitizedValue * ( arr[active].rate - arr[active].rate * arr[active].dis_per / 100)
      setData(arr)
     }
}
 function handleCheckboxChange(index) {
const arr = [...data]
setData([])
arr[index].is_verify = arr[index].is_verify ? false : true
console.log(arr[index])
setData(arr)
}

console.log(verifyEnable === false ? "disable" : "enable")
// function checkBarcode(e){
//   console.log(data)
//   const arr=[...data]
//   setData([])
//   setBarCode(e.target.value.replace(/\D/g, "").trim());
//   const barcode = e.target.value.replace(/\D/g, "").trim();
//   console.log(barcode)
//   let barcodeFound = false;

//   const newData = []; // New array to store modified data
//   let removedValue = null; // Variable to store the removed value, initially null

// for (const item of arr) {
//     const index = item.barcodeData.indexOf(barcode);
//     console.log(index, item.barcodeData, data[index]);
//     if (index !== -1) {
//         removedValue = item.barcodeData.splice(index, 1)[0];
//         item.barcodeData = item.barcodeData.slice(0, index).concat(item.barcodeData.slice(index + 1));

//         console.log(`Barcode ${barcode} removed from barcodeData.`);
//         dispatch(setSnackbar(true, 'success', 'Barcode Verified'));
//         setBarCode("");
//         barcodeFound = true;
//         break; // Exit the loop once barcode is found
//     } 
// }

// if(removedValue){
//   newData.push(removedValue)
//   removedValue = null
// }
// console.log(newData,'Removed Data')
//         setData(arr)

// if (!barcodeFound) {
//     console.log(`Barcode ${barcode} not found in barcodeData.`);
//     dispatch(setSnackbar(true, 'error', 'Already stock verified!'));
//     setBarCode("");
// }

// }
function checkBarcode(e) {
  const barcode = e.target.value.replace(/\D/g, "").trim();
  setBarCode(barcode);
}
const enterBarcode = async (e) => {
  if (e.key === 'Enter') {
    if (barCode.length <= 11) {
      dispatch(setSnackbar(true, 'error', 'Invalid Barcode'));
      setBarCode("");
      return;
    }

    const updatedData = [...data]; 
    let barcodeFound = false;

    for (const item of updatedData) {
      const index = item.barcodeData.indexOf(barCode);
      if (index !== -1) {
        const payload = {
          docno: item.docno,
          docdate: moment().format('YYYY-MM-DD'),
          prodid : item.prodid,
          barcode: barCode,
          pro_code: item.pro_code,
          description: item.pro_name,
          mrp: item.mrp,
          gst_per: item.gst_per,
          rate: item.rate,
          dis_per: item.dis_per,
          qty: item.qty || 0,
          gst_amt: item.gst_amt,
          amount: item.totalAmt,
          sales_details_id : item.id,
        };

        try {
          await axios.post('/v1/stock_scan', payload);

          const removedBarcode = item.barcodeData.splice(index, 1)[0];
          item.verifiedCode.push(removedBarcode);
          item.scanned_count = (item.scanned_count || 0) + 1;

          barcodeFound = true;
          setData(updatedData); 
          dispatch(setSnackbar(true, 'success', 'Barcode Verified'));
          setBarCode("");

          // Fetch sales data
          const salesResponse = await axios.get(`/v1/sales/${item.docno}`);
          console.log('Sales data fetched successfully:', salesResponse.data);

        } catch (error) {
          // console.error('Error during barcode scanning or fetching sales:', error.response || error.message);
          // dispatch(setSnackbar(true, 'error', 'Failed to scan barcode!'));
          setBarCode("");
        }

        break;
      }
    }

    if (!barcodeFound) {
      dispatch(setSnackbar(true, 'error', 'Barcode Scanned already!'));
      setBarCode("");
    }
  }
};

// function enterBarcode(e) {
//   if (e.key === 'Enter') {
//     if (barCode.length <= 11) {
//       dispatch(setSnackbar(true, 'error', 'Invalid Barcode'));
//       setBarCode("");
//       return;
//     }

//     const arr = [...data]; // Create a copy of the data array
//     let barcodeFound = false;

//     // Loop through each item in the array to find the barcode
//     for (const item of arr) {
//       const index = item.barcodeData.indexOf(barCode);
//       if (index !== -1) {
//         // Prepare the request payload, including required fields
//         const payload = {
//           docno: item.docno,
//           docdate: moment().format('YYYY-MM-DD'),
//           barcode: barCode,
//           pro_code: item.pro_code,
//           description: item.pro_name,
//           mrp: item.mrp,
//           gst_per: item.gst_per,
//           rate: item.rate,
//           dis_per: item.dis_per,
//           qty: item.qty || 0,
//           gst_amt: item.gst_amt,
//           amount: item.totalAmt,
//         };

//         // Call the API to scan the barcode
//         axios
//           .post('/v1/stock_scan', payload)
//           .then((response) => {
//             // Handle success response
//             const removedBarcode = item.barcodeData.splice(index, 1)[0];
//             item.verifiedCode.push(removedBarcode); // Add the removed barcode to verifiedCode
            
//             // Increment the scanned count after a successful scan
//             item.scanned_count = (item.scanned_count || 0) + 1;
            
//             barcodeFound = true;
//             setData(arr); // Update the state with modified data
//             dispatch(setSnackbar(true, 'success', 'Barcode Verified'));
//             setBarCode("");
         
//           })
//           .catch((error) => {
//             // Handle error response
//             dispatch(setSnackbar(true, 'error', 'Failed to scan barcode!'));
//             setBarCode("");
//           });

//         break; // Exit the loop once the barcode is found
//       }
//     }

//     // If barcode was not found in the stock
//     if (!barcodeFound) {
//       dispatch(setSnackbar(true, 'error', 'Barcode not found in stock!'));
//       setBarCode("");
//     }
//   }
// }

// function enterBarcode(e) {
//   if (e.key === 'Enter') {
//     if (barCode.length <= 11) {
//       dispatch(setSnackbar(true, 'error', 'Invalid Barcode'));
//       setBarCode("");
//       return;
//     }

//     const arr = [...data]; // Create a copy of the data array
//     let barcodeFound = false;

//     // Loop through each item in the array to find the barcode
//     for (const item of arr) {
//       const index = item.barcodeData.indexOf(barCode);
//       if (index !== -1) {
//         // Prepare the request payload, including required fields
//         const payload = {
//           docno: item.docno, // Example docno, update as needed
//           docdate: moment().format('YYYY-MM-DD'), // Use current date or set as needed
//           barcode: barCode,
//           pro_code: item.pro_code, // Assuming pro_code is available on the item
//           description: item.pro_name, // Assuming description is available on the item
//           mrp: item.mrp, // Assuming mrp is available on the item
//           gst_per: item.gst_per, // Assuming gst_per is available on the item
//           rate: item.rate, // Assuming rate is available on the item
//           dis_per: item.dis_per, // Assuming dis_per is available on the item
//           qty: item.qty || 0, // Assuming retQty is the quantity being scanned
//           gst_amt: item.gst_amt, // Assuming gst_amt is available on the item
//           amount: item.totalAmt // Assuming totalAmt is available on the item
//         };

//         // Call the API to scan the barcode
//         axios.post('/v1/stock_scan', payload)
//           .then(response => {
//             // Handle success response
//             const removedBarcode = item.barcodeData.splice(index, 1)[0];
//             item.verifiedCode.push(removedBarcode); // Add the removed barcode to verifiedCode
//             barcodeFound = true;
//             setData(arr); // Update the state with modified data
//             dispatch(setSnackbar(true, 'success', 'Barcode Verified'));
//             setBarCode("");
//             // window.location.reload();
//           })
//           .catch(error => {
//             // Handle error response
//             dispatch(setSnackbar(true, 'error', 'Failed to scan barcode!'));
//             setBarCode("");
//           });

//         break; // Exit the loop once the barcode is found
//       }
//     }

//     // If barcode was not found in the stock
//     if (!barcodeFound) {
//       dispatch(setSnackbar(true, 'error', 'Barcode not found in stock!'));
//       setBarCode("");
//     }
//   }
// }

useEffect(() => {
if(data.length > 0){
  // .filter(value=>value.retQty > 0)
  const arr = data.flatMap(val => {
    return val.barcodeData.map(item=>({
      docdate: moment().format('YYYY/MM/DD'),
      prodid:val.id,
      dis_per:val.dis_per,
      dis_amt: val.dis_amt,
      mrp: val.mrp,
      rate: val.rate,
      qty: val.retQty,
      gst_per: val.gst_per,
      gst_amt: val.gst_amt,
      cess_per: val.cess_per,
      cess_amt: val.cess_amt,
      head_id:val.head_id,
      type_id:val.type_id,
      subcat_id:val.subcat_id,
      cat_id:val.cat_id,
      uom_id:val.uom_id,
      barcode: item,
      barcode_to: item,
      company_id: val.company_id,
      is_verify:val.is_verify !== undefined ? val.is_verify : "false"
    }))
  })
  console.log(data,'Data varuthu')
  console.log(arr)
 const arr2 =  data.map(item => item.verifiedCode).reduce((acc, curr) => acc.concat(curr), []);
 console.log(arr2)
  setPostData((prevState) => ({...prevState , stock_missing_details : arr, verifiedCode: arr2}))
}
},[data,])

useEffect(()=>{
  if(data.length > 0){
    data.forEach(item => {
      if (item.barcodeData.length === 0) {
        item.is_verify = true;
      }
    });
  }
},[data])

return (
    <Grid className="w-full " >
      <Grid className='flex justify-end py-1 pb-1'>
        <TextField size="small" placeholder="Search By Barcode"
          onChange={checkBarcode}
          value={barCode}
          onKeyPress={enterBarcode}
        />
      </Grid>
      <Grid sx={{  height: data.length > 0 ? "450px" : "100%" , overflow: "auto" }}>
      <TableContainer className={classes.tblRoot}>
        <Table stickyHeader  className={classes.table}>
          <TableHead className={classes.tblHeader}>
            <TableRow className={classes.tablrow}>
              <TableCell className={classes.tblCell} sx={{borderLeft:'0.5px solid  #ccc', minWidth:100}}>Sno</TableCell>
              <TableCell className={classes.tblCell}>Product Code</TableCell>
              <TableCell className={classes.tblCell}>Description</TableCell>
              <TableCell className={classes.tblCell}>MRP</TableCell>
              <TableCell className={classes.tblCell}>GST%</TableCell>
              <TableCell className={classes.tblCell}>Rate</TableCell>
              <TableCell className={classes.tblCell}>Dis%</TableCell>
              <TableCell className={classes.tblCell}>Qty</TableCell>
              <TableCell className={classes.tblCell}>Count</TableCell>
              {/* <TableCell className={classes.tblCell}>Return Qty</TableCell> */}
              <TableCell className={classes.tblCell}>GST</TableCell>
              {/* <TableCell className={classes.tblCell}>CESS</TableCell> */}
              <TableCell className={classes.tblCell}>Amount</TableCell>
              {/* <TableCell className={classes.tblCell}>Stock verify</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? _.map(data, (val, idx) => (
               <TableRow className={classes.tablrow} key={idx} onClick={() => getSelectedRow(idx)}>
               <TableCell  padding="checkbox" className={classes.tblContentCell}>{idx + 1}</TableCell>
                     <TableCell>{val.pro_code}</TableCell>
               <TableCell variant="body" className={classes.tblContentCell}>{val.pro_name}</TableCell>
               <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{Math.round(val.mrp)}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{Math.round(val.gst_per)}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{Math.round(val.rate)}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{parseInt(val.dis_per)}%</TableCell>
               <TableCell>{val.qty}</TableCell>
               {/* <TableCell>{val.barcodeData.length}</TableCell> */}
               {/* <TableCell className={classes.tblContentCell} sx={{width:100}}>
                <TextField
                size="small"
                inputRef={qtyRef}
                value={val.retQty}
                onChange={handleQtyChange}
                />
                
               </TableCell> */}
                 <TableCell className={classes.tblContentCell} sx={{width:100}}>
                    {/* {parseFloat(val.original_qty) - parseFloat(val.scanned_count || 0)} */}
                    {Math.max(parseFloat(val.original_qty) - parseFloat(val.scanned_count || 0), 0)}
                    </TableCell>
               <TableCell className={classes.tblContentCell} sx={{width:100}}>{Math.round(val.gst_amt)}</TableCell>
               {/* <TableCell className={classes.tblContentCell} sx={{width:100}}>{val.cess_amt}</TableCell> */}
               <TableCell className={classes.tblContentCell} sx={{width:100}}>{parseFloat(val.totalAmt).toFixed(0)}</TableCell>
            {/* <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell> */}
               {/* <TableCell className={classes.tblContentCell} sx={{width:100}}><IconButton><Delete sx={{color:'red', fontSize:18}}/></IconButton></TableCell> */}
               {/* <TableCell>
                  <Checkbox
                    checked={val.is_verify}
                    defaultChecked={val.barcodeData.length===0}
                    onChange={() => handleCheckboxChange(idx)}
                    disabled={val.barcodeData.length===0}
                  />
                </TableCell> */}
             </TableRow>
            )) :
            <TableRow className={classes.tablrow}>
            <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{data.length + 1}</TableCell>
            <TableCell  padding="checkbox" sx={{ width: 120 }} className={classes.tblContentCell}></TableCell>
            <TableCell variant="body" className={classes.tblContentCell}></TableCell>
            <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}></TableCell>
            <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}></TableCell>
            <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}></TableCell>
            <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}></TableCell>
            <TableCell  padding="checkbox" sx={{ width: 120 }}  className={classes.tblContentCell}></TableCell>
            <TableCell  padding="checkbox" sx={{ width: 120 }}  className={classes.tblContentCell}></TableCell>
            {/* <TableCell  padding="checkbox" sx={{ width: 120 }}  className={classes.tblContentCell}></TableCell> */}
            <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell>
            {/* <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell> */}
            <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell>
            {/* <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell> */}
          </TableRow>
          }
          </TableBody>
        </Table>
      </TableContainer>
      </Grid>
      
    </Grid>
  );
};
export default memo(BillingTable);